'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPrevTabbableElementInclusive = exports.getNextTabbableElementExclusive = exports.getTabbableElements = exports.elementIsOnScreen = exports.closest = exports.matches = exports.elementHasClass = undefined;

var _Selectors = require('../constants/Selectors');

var _underscore = require('../utils/underscore');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// Polyfill for el.classList.contains(className) that doesn't fail for SVGs in IE11
var elementHasClass = exports.elementHasClass = function elementHasClass(el, className) {
  return !!(el && el.classList && el.classList.contains(className));
};

// Polyfill for el.matches(selector)
var matches = exports.matches = function matches(el, selector) {
  if (!el) {
    return false;
  }
  if (el.matches) {
    return el.matches(selector);
  }
  if (el.msMatchesSelector) {
    return el.msMatchesSelector(selector);
  }
  if (el.parentElement) {
    var matchingSiblings = el.parentElement.querySelectorAll(selector);
    for (var i = 0; i < matchingSiblings.length; i++) {
      if (matchingSiblings[i] === el) {
        return true;
      }
    }
  }
  return false;
};

// Polyfill for el.closest(selector)
var closest = exports.closest = function closest(el, selector) {
  if (!el) {
    return null;
  }
  if (el.closest) {
    return el.closest(selector);
  }
  do {
    if (matches(el, selector)) {
      return el;
    }
    el = el.parentElement;
  } while (el);
  return null;
};

// Is el within the bounds of the given screen?
var elementIsOnScreen = exports.elementIsOnScreen = function elementIsOnScreen(el) {
  var screen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

  var elementBounds = el.getBoundingClientRect();
  var xWithinBounds = elementBounds.right >= 0 && elementBounds.left <= screen.innerWidth;
  var yWithinBounds = elementBounds.bottom >= 0 && elementBounds.top <= screen.innerHeight;
  return xWithinBounds && yWithinBounds;
};

// Is el visible (for tabbing purposes)?
var elementIsVisible = function elementIsVisible(el) {
  return window.getComputedStyle(el, null).visibility !== 'hidden';
};

// Returns an array containing every tabbable element within the given container. The array order
// reflects the tabbing order, unless positive tabIndex values (e.g. tabIndex={7}) are used.
// Such tabIndex values are exceedingly rare in modern web apps, so don't worry about it.
var getTabbableElements = exports.getTabbableElements = function getTabbableElements(container) {
  return [].concat(_toConsumableArray(container.querySelectorAll(_Selectors.FOCUSABLE))).filter(function (el) {
    // Hidden elements aren't tabbable. Sadly, no CSS query can exclude such elements.
    return elementIsVisible(el);
  });
};

// Returns the next element after the given element (and its descendants) in the document tab order.
var getNextTabbableElementExclusive = exports.getNextTabbableElementExclusive = function getNextTabbableElementExclusive(startEl) {
  var allElements = [].concat(_toConsumableArray(document.querySelectorAll('*')));
  for (var i = allElements.indexOf(startEl) + 1; i < allElements.length; i++) {
    var el = allElements[i];
    if (startEl.contains(el)) {
      continue;
    }
    if (matches(el, _Selectors.FOCUSABLE) && elementIsVisible(el)) {
      return el;
    }
  }
  return null;
};

// Returns the previous element in the document tab order, *including* the given element and its
// descendants. This is equivalent to what the browser would focus if the user pressed Shift+Tab
// from the nextSibling of the given element, for example.
var getPrevTabbableElementInclusive = exports.getPrevTabbableElementInclusive = function getPrevTabbableElementInclusive(startEl) {
  var focusableDescendants = getTabbableElements(startEl);
  if (focusableDescendants.length) {
    return (0, _underscore.last)(focusableDescendants);
  }
  if (matches(startEl, _Selectors.FOCUSABLE)) {
    return startEl;
  }
  var allElements = [].concat(_toConsumableArray(document.querySelectorAll('*')));
  for (var i = allElements.indexOf(startEl) - 1; i >= 0; i--) {
    var el = allElements[i];
    if (matches(el, _Selectors.FOCUSABLE) && elementIsVisible(el)) {
      return el;
    }
  }
  return null;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.348/js/utils/Dom.js
// module id = 264
// module chunks = 0 1